import type { BuildingTechnicalSystemsSections } from "../../../types/buildings-sections/technical-systems";

export const technicalSystems: BuildingTechnicalSystemsSections = {
  title: "Tehnilised Süsteemid",
  description: "Tehniliste süsteemide andmed",
  type: "Tüüp",
  location: "Asukoht",
  manufacturer: "Tootja",
  model: "Mudel",
  lastMaintenanceDate: "Viimane Hooldus",
  capacity: "Võimsus",
  addSystem: "Lisa Süsteem",
  selectType: "Vali Süsteemi Tüüp",
  noDataAvailable: "Tehniliste süsteemide andmed puuduvad",
  addedSuccessfully: "Tehniline süsteem edukalt lisatud",
  deletedSuccessfully: "Tehniline süsteem edukalt kustutatud",
  addError: "Tehnilise süsteemi lisamine ebaõnnestus",
  creatingRecord: "Tehnilise süsteemi loomine...",
  systemType: "Süsteemi tüüp",
  installationDate: "Paigalduskuupäev",
  installationYear: "Paigaldusaasta",
  userManualLink: "Kasutusjuhendi link",
  warrantyInfo: "Garantii info",
  maintenanceRequirements: "Hoolduse nõuded",
  expectedLifetime: "Eeldatav eluiga",
  systemTypes: {
    hvac: "HVAC",
    electrical: "Elektrisüsteem",
    plumbing: "Torusüsteem",
    fire: "Tulekaitse",
    security: "Turvalisus",
    automation: "Hooneautomaatika",
    elevator: "Lift",
    communication: "Side",
    electricalSystem: "Elektrisüsteem",
    waterSystem: "Veesüsteem",
    sewerSystem: "Kanalisatsioonisüsteem",
    heatingSystem: "Küttesüsteem",
    ventilationSystem: "Ventilatsioonisüsteem",
    coolingSystem: "Jahutussüsteem",
    gasSystem: "Gaasisüsteem",
  },
};
